/* eslint-disable no-case-declarations */
import { fromJS, Map, List } from 'immutable'

import {
  RESET_CAMPAIGNS_LOADED,
  SET_CAMPAIGNS,
  SET_CAMPAIGN_SESSIONS,
  SET_CAMPAIGN_SESSION,
  SET_CAMPAIGN_TARGETS,
  SET_CAMPAIGN_LEADS,
  SET_CAMPAIGN_ROOMS,
  DELETE_CAMPAIGN,
  UPDATE_CAMPAIGN,
  ADD_CAMPAIGN,
  SET_CAMPAIGN_INFO
} from '../actions'

export const initialState = new Map({
  behaviors: new List(),
  campaigns: new List(),
  hm_short_tag: null,
  campaignInfo: null,
  next: null,
  previous: null,
  loaded: false
})

let indexOfListToUpdate = null

const campaignReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case RESET_CAMPAIGNS_LOADED:
      return state
        .set('campaigns', new List())
        .set('count', 0)
        .set('next', null)
        .set('previous', null)
        .set('loaded', false)

    case SET_CAMPAIGNS:
      return state
        .set('campaigns', fromJS(action.data.results))
        .set('count', action.data.results.length)
        .set('next', action.data.next)
        .set('previous', action.data.previous)
        .set('loaded', true)

    case ADD_CAMPAIGN:
      const campaigns = state.get('campaigns')
      return state.setIn(['campaigns'], campaigns.unshift(fromJS(action.data)))

    case UPDATE_CAMPAIGN:
      indexOfListToUpdate = state
        .get('campaigns')
        .findIndex((campaign) => campaign.get('id') === action.campaignId)
      return state.setIn(['campaigns', indexOfListToUpdate], fromJS(action.data))

    case DELETE_CAMPAIGN:
      indexOfListToUpdate = state
        .get('campaigns')
        .findIndex((campaign) => campaign.get('id') === action.campaignId)
      return state.removeIn(['campaigns', indexOfListToUpdate])

    case SET_CAMPAIGN_SESSIONS:
      indexOfListToUpdate = state
        .get('campaigns')
        .findIndex((campaign) => campaign.get('id') === action.campaignId)
      return state.setIn(
        ['campaigns', indexOfListToUpdate, 'sessions'],
        fromJS(action.data.results)
      )

    case SET_CAMPAIGN_SESSION:
      indexOfListToUpdate = state
        .get('campaigns')
        .findIndex((campaign) => campaign.get('id') === action.campaignId)
      const session = state.getIn(['campaigns', indexOfListToUpdate, 'sessions'])
      return state.setIn(
        ['campaigns', indexOfListToUpdate, 'sessions'],
        session.push(fromJS(action.data))
      )

    case SET_CAMPAIGN_TARGETS:
      indexOfListToUpdate = state
        .get('campaigns')
        .findIndex((campaign) => campaign.get('id') === action.campaignId)
      return state
        .setIn(['campaigns', indexOfListToUpdate, 'targets'], fromJS(action.data))
        .setIn(['campaigns', indexOfListToUpdate, 'targetsLoaded'], true)

    case SET_CAMPAIGN_LEADS:
      indexOfListToUpdate = state
        .get('campaigns')
        .findIndex((campaign) => campaign.get('id') === action.campaignId)
      return state
        .setIn(['campaigns', indexOfListToUpdate, 'leads'], fromJS(action.data))
        .setIn(['campaigns', indexOfListToUpdate, 'leadsLoaded'], true)

    case SET_CAMPAIGN_ROOMS:
      indexOfListToUpdate = state
        .get('campaigns')
        .findIndex((campaign) => campaign.get('id') === action.campaignId)
      const rooms = new Map({ results: action.data.results, count: action.data.count })
      return state
        .setIn(['campaigns', indexOfListToUpdate, 'rooms'], fromJS(rooms))
        .setIn(['campaigns', indexOfListToUpdate, 'roomsLoaded'], true)

    case SET_CAMPAIGN_INFO:
      return state.set('campaignInfo', action.data)

    default:
      return state
  }
}

export default campaignReducer
